import { onGetGroups } from 'redux/groups/sagas/getGroups';
import { onGetGroupItems } from 'redux/groups/sagas/getGroupItems';
import { onAddGroupItem } from 'redux/groups/sagas/addGroupItem';
import { onDeleteGroup } from 'redux/groups/sagas/deleteGroup';
import { onAddGroup } from 'redux/groups/sagas/addGroup';
import { onDeleteGroupItem } from 'redux/groups/sagas/deleteGroupItem';
import { onUpdateGroup } from 'redux/groups/sagas/updateGroup';
import { onUpdateGroupItem } from 'redux/groups/sagas/updateGroupItem';

import { call, all } from 'redux-saga/effects';

export default function* groupsSaga() {
  yield all([
    call(onAddGroup),
    call(onAddGroupItem),
    call(onDeleteGroup),
    call(onDeleteGroupItem),
    call(onGetGroups),
    call(onGetGroupItems),
    call(onUpdateGroup),
    call(onUpdateGroupItem),
  ]);
}
